export default __webpack_public_path__ + "95add365fd3437d3b455a833fd4ac2af.png";